/* eslint-disable @typescript-eslint/no-explicit-any */
import { RefObject, SyntheticEvent } from 'react';
import { TEventsHandlers } from './types';

type TEventHandler = (event: any) => unknown;

export type TEvent =
  | 'blur'
  | 'change'
  | 'click'
  | 'focus'
  | 'keydown'
  | 'keyup'
  | 'mousedown'
  | 'mouseup';

export function getEventHandler(
  eventName: TEvent,
  handlers: RefObject<TEventsHandlers>,
) {
  return (currentEvent: any) => {
    if (handlers.current?.disabled) return;

    let parentHandler: TEventHandler | undefined;
    let handler: TEventHandler | undefined;
    switch (eventName) {
      case 'change':
        parentHandler = handlers.current?.parentOnChange;
        handler = handlers.current?.onChange;
        break;
      case 'click':
        parentHandler = handlers.current?.parentOnClick;
        handler = handlers.current?.onClick;
        break;
      case 'keydown':
        parentHandler = handlers.current?.parentOnKeyDown;
        handler = handlers.current?.onKeyDown;
        break;
      case 'keyup':
        parentHandler = handlers.current?.parentOnKeyUp;
        handler = handlers.current?.onKeyUp;
        break;
      case 'mousedown':
        parentHandler = handlers.current?.parentOnMouseDown;
        handler = handlers.current?.onMouseDown;
        break;
      case 'mouseup':
        parentHandler = handlers.current?.parentOnMouseDown;
        handler = handlers.current?.onMouseDown;
        break;
      case 'blur':
        parentHandler = handlers.current?.parentOnBlur;
        handler = handlers.current?.onBlur;
        break;
      case 'focus':
        parentHandler = handlers.current?.parentOnFocus;
        handler = handlers.current?.onFocus;
        break;
      default:
        break;
    }

    const casted = (currentEvent as SyntheticEvent).nativeEvent;
    parentHandler?.(casted);
    if (!casted.defaultPrevented) handler?.(casted);
  };
}
